module.exports = __webpack_public_path__ + "media/2.2_tabla_9_cf1.54d04c7a.wav";